/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Button, Modal, TableProps } from 'antd';
import TableComponent from '../table';
import { IDoOrder, IDoOrderReq, IDoOrderRes } from '@/interfaces/doOrder';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { searchDoOrders } from '@/adapters/doOrder';
import { formatDate, formatNumber } from '@/utils/dataUtils';

interface IProps {
  open: boolean;
  productId: number;
  handleCancel: () => void;
}

const _criteria: IDoOrderReq = {
  pageSize: -1,
  pageStart: 1,
};

const DoOrderTableModal = ({ open, handleCancel, productId }: IProps) => {
  const [criteria] = useState<IDoOrderReq>({
    ..._criteria,
  });

  const columns: TableProps<IDoOrder>['columns'] = [
    {
      title: 'DO NUMBER',
      dataIndex: 'code',
      key: 'code',
      align: 'center',
      className: 'font-bold',
      width: 160,
    },
    {
      title: 'INV NUMBER',
      dataIndex: 'ivNo',
      key: 'ivNo',
      render: (_, rec) => rec?.inboundItems?.map(c => c.invNO).join(', '),
    },
    {
      title: 'ITEM CODE',
      dataIndex: 'productCode',
      key: 'productCode',
      className: 'font-bold',
      align: 'center',
      width: 160,
    },
    {
      title: 'ITEM NAME',
      dataIndex: 'productName',
      key: 'productName',
      className: 'font-bold',
    },
    {
      title: 'VOLUMN',
      dataIndex: 'quantity',
      key: 'quantity',
      className: 'font-bold',
      align: 'right',
      width: 120,
      render: _ => formatNumber(_),
    },
    {
      title: 'REQUEST ETD SIN',
      dataIndex: 'requestEtdSin',
      key: 'requestEtdSin',
      align: 'center',
      render: _ => formatDate(_),
      width: 160,
    },
    {
      title: 'REQUEST ETA BKK',
      dataIndex: 'requestEtaBkk',
      key: 'requestEtaBkk',
      align: 'center',
      render: _ => formatDate(_),
      width: 160,
    },
    {
      title: 'UPDATED ETD SIN',
      dataIndex: 'updateEtdSin',
      key: 'updateEtdSin',
      align: 'center',
      render: _ => formatDate(_),
      width: 160,
    },
    {
      title: 'UPDATED ETA BKK',
      dataIndex: 'updateEtaBkk',
      key: 'updateEtaBkk',
      align: 'center',
      render: _ => formatDate(_),
      width: 160,
    },
    {
      title: 'VOLUMN',
      dataIndex: 'remain',
      key: 'remain',
      className: 'font-bold',
      align: 'right',
      width: 120,
      render: _ => formatNumber(_),
    },
  ];
  const { data, isLoading } = useQuery<AxiosResponse<IDoOrderRes>, Error>({
    queryKey: ['search-doOrder', criteria],
    queryFn: async () =>
      await searchDoOrders({ ..._criteria, productId: productId }),
    enabled: !!productId,
  });

  return (
    <Modal
      title="DO List"
      open={open}
      width={'1450px'}
      onCancel={handleCancel}
      cancelText="ยกเลิก"
      footer={[
        <Button key="back" onClick={handleCancel}>
          ปิด
        </Button>,
      ]}
    >
      <div className="flex flex-col gap-3 w-full">
        <TableComponent<IDoOrder>
          columns={columns}
          criteria={undefined}
          data={data?.data || { data: [], totalRecords: 0 }}
          loading={isLoading}
          onTableChange={undefined}
          scrollLength={1400}
          scroll
          showPagination={false}
        />
      </div>
    </Modal>
  );
};

export default DoOrderTableModal;
